import { Suspense } from "react";
import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import { PageLoader } from "@circle-react/pages/PageLoader";

const ConnectSettingsComponent = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "MessagingSettingsPage" */ "@circle-react/components/SettingsApp/Connect"
    ),
);

export const ConnectSettingsPage = () => (
  <Suspense fallback={<PageLoader />}>
    <ConnectSettingsComponent />
  </Suspense>
);
